import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'

import { CustomModal, InputText, CustomCheckbox, Btn } from '../../../../components'
import * as CentralHttp from '../../../../services/api/https/settings/operation-center.http'
import { showMessageBox } from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'

const ModalCentralOperacao = ({ dispatch, data, show, onModalSave, onModalClose }) => {
  const [state, setState] = useState(data)

  useEffect(() => {
    show && setState({ ...data })
  }, [show, setState])

  // Events
  const onBtnSalvarClicked = async () => {
    try {
      const { id, name, actived } = state
      if (name.trim().length < 3) {
        throw new Error('Nome da Central de Operação está Incorreto')
      }
      let central
      if (id) {
        central = await CentralHttp.updateCentralOperacoes({ id, name, actived })
      } else {
        central = await CentralHttp.saveCentralOperacoes({ name, actived })
      }
      onModalSave(central)
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    }
  }

  // Render
  return (
    <CustomModal header="Central de Operação" isVisible={show} onClose={onModalClose}>
      <form className="p-grid">
        <div className="p-col-12">
          <InputText
            label="Descrição :"
            marginTop={10}
            value={state && state.name ? state.name : ''}
            onChange={value => setState({ ...state, name: value })}
          />
        </div>
        <div className="p-col-12">
          <CustomCheckbox
            onChange={value => setState({ ...state, actived: value })}
            checked={state && state.actived ? state.actived : false}
          >
            Ativo
          </CustomCheckbox>
        </div>
        <div className="p-col-12">
          <Btn onClick={onBtnSalvarClicked}>Salvar</Btn>
        </div>
      </form>
    </CustomModal>
  )
}

export default connect()(ModalCentralOperacao)
